import { EUnavailableReason } from '../../../../../../types/reducers/publishTerms';
import { IPublishTerm } from '../../../../../../repositories/billing-tariffs/entities/PublishTerms/PublishTerm';

export const isPromotionForbidden = (terms: IPublishTerm[] | undefined) => {
  return (
    terms &&
    Boolean(terms.length) &&
    terms.every(
      ({ unavailableReasonType: r }) =>
        r && (r as string as EUnavailableReason) === EUnavailableReason.DeniedBySanctions,
    )
  );
};
